module.exports = __webpack_public_path__ + "bbe328ccbc6889a186a45022795aa876.fbx";